




import VueOptions from '@utils/VueOptions'
import AdvanceWizard from '@sponsorComponents/Advance/Wizard/AdvanceWizard'

settings =
  name: "AdvanceEditPage"
  components: { AdvanceWizard }
  vue:
    computed: 
      advanceId: -> @$route.params.advanceId
      offerId: -> @$route.params.offerId

export default VueOptions.vue settings
